import { Howl } from 'howler'
import spinSound from '../audios/roulette_spin.mp3'
import winSound from '../audios/Win_Tone.mp3'
import chipPlaceSound from '../audios/Modern UI Sound.mp3'

const spinAudio = new Howl({
  src: [spinSound],
  loop: false
})

const winAudio = new Howl({
  src: [winSound],
  loop: false
})

const chipPlaceAudio = new Howl({
  src: [chipPlaceSound],
  loop: false
})

const placeBetClickAudio = new Howl({
  src: ['/assets/music/button-click.wav'],
  loop: false
})

export function soundVolume (value) {
  spinAudio?.volume(value)
  winAudio?.volume(value)
  chipPlaceAudio?.volume(value)
  placeBetClickAudio?.volume(value)
}

export function playSpinSound () {
  spinAudio?.play()
}

export function playWinSound () {
  winAudio?.play()
}

export function playChipPlaceSound () {
  chipPlaceAudio?.play()
}

export function playPlaceBetClickSound () {
  placeBetClickAudio?.play()
}
